<template>
  <a-modal
    :title="title"
    :visible="visible"
    width="500px"
    data-testid="delete-confirmation-modal"
    @cancel="cancel"
    :destroy-on-close="true"
    v-if="visible"
  >
    <div class="flex flex-column gap-2" data-testid="delete-confirmation-content">
      <p v-text="description"></p>
      <p v-if="confirmText" v-text="confirmText"></p>
      <p v-else>
        Type <b>{{ action }}</b> in the field below to confirm.
      </p>

      <a-input
        v-model="confirmation"
        :placeholder="inputPlaceholder || requiredConfirmation"
        data-testid="delete-confirmation-input"
      />
      <div
        v-if="helperText && confirmation !== requiredConfirmation"
        class="modal-delete__helper"
        data-testid="delete-confirmation-helper"
      >
        {{ helperText }}
      </div>
    </div>

    <template slot="footer">
      <div class="flex justify-content-between" data-testid="delete-confirmation-footer">
        <a-button @click="cancel" data-testid="delete-confirmation-cancel-button"> Cancel </a-button>
        <a-button
          type="danger"
          @click="handleConfirm"
          :loading="loading"
          :disabled="confirmation !== requiredConfirmation"
          data-testid="delete-confirmation-submit-button"
        >
          {{ confirmButtonText || capitalize(action) }}
        </a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import util from '@/util'
import { Button, Input, notification } from 'ant-design-vue'

export default {
  components: {
    'a-input': Input,
    'a-button': Button
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Delete'
    },
    description: {
      type: String,
      default: ''
    },
    onConfirm: { type: Function, default: () => {} },
    action: {
      type: String,
      default: 'delete'
    },
    confirmText: {
      type: String,
      default: ''
    },
    confirmationValue: {
      type: String,
      default: undefined
    },
    inputPlaceholder: {
      type: String,
      default: ''
    },
    helperText: {
      type: String,
      default: ''
    },
    confirmButtonText: {
      type: String,
      default: ''
    }
  },
  data() {
    return { loading: false, confirmation: '' }
  },
  computed: {
    requiredConfirmation() {
      return this.confirmationValue ?? this.action
    }
  },
  methods: {
    capitalize: util.capitalize,
    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    cancel() {
      this.confirmation = ''
      this.$emit('update:visible', false)
    },

    async handleConfirm() {
      this.loading = true
      try {
        await this.onConfirm()

        this.cancel()
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.modal-delete__helper {
  color: #ef4444;
  font-size: 12px;
}
</style>
